import { computed } from "vue";

// Renders the merchant's pure-HTML landing-page header inside a sandboxed iframe
// so its CSS/JS can't leak into the donation form.
export default (formData) => {
    // <base> so merchant links open the parent page, not the sandboxed frame.
    const htmlHeaderSrcdoc = computed(() => `<base target="_parent">${formData.form_header_page_template || ''}`);

    const resizeHtmlFrame = (event) => {
        const iframe = event.target;
        const doc = iframe.contentDocument || iframe.contentWindow?.document;
        if (! doc) return;

        const fit = () => iframe.style.height = `${doc.documentElement.scrollHeight}px`;
        fit();

        if (iframe.contentWindow.ResizeObserver) {
            new iframe.contentWindow.ResizeObserver(fit).observe(doc.body);
        }
    };

    return { htmlHeaderSrcdoc, resizeHtmlFrame };
}
